export default __webpack_public_path__ + "static/media/09.00087c54.jpg";